import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import AskAIChat from '../../pages/Stocks/AskAIChat';

/**
 * Floating "Ask AI" launcher: a fixed bubble (bottom-right) that expands into a compact
 * chat panel. Mounted once globally so it appears on every page. Reuses <AskAIChat/> and the
 * same backend/budget as the full /ask-ai page. Hidden on the /ask-ai page itself (redundant).
 */
const AskAIWidget = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  // Don't show the bubble on the dedicated full-page chat.
  if (location.pathname === '/ask-ai') return null;

  return (
    <div className="fixed bottom-5 right-5 z-50 flex flex-col items-end">
      {open && (
        <div className="mb-3 w-[22rem] max-w-[calc(100vw-2.5rem)] h-[28rem] bg-white rounded-xl shadow-2xl border border-gray-200 flex flex-col overflow-hidden">
          <div className="flex items-center justify-between px-4 py-2 bg-blue-600 text-white">
            <span className="font-semibold text-sm">Ask AI</span>
            <button
              aria-label="Close chat"
              className="text-white/90 hover:text-white text-lg leading-none"
              onClick={() => setOpen(false)}
            >
              ×
            </button>
          </div>
          <div className="flex-1 overflow-hidden">
            {/* active only once opened, so history loads on first open */}
            <AskAIChat active={open} />
          </div>
        </div>
      )}

      <button
        aria-label={open ? 'Close Ask AI' : 'Open Ask AI'}
        onClick={() => setOpen((v) => !v)}
        className="w-14 h-14 rounded-full bg-blue-600 hover:bg-blue-700 text-white shadow-lg flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-blue-400"
      >
        {open ? (
          <span className="text-2xl leading-none">×</span>
        ) : (
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
              d="M8 10h.01M12 10h.01M16 10h.01M21 12c0 4.418-4.03 8-9 8a9.77 9.77 0 01-4-.8L3 20l1.3-3.9A7.96 7.96 0 013 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
          </svg>
        )}
      </button>
    </div>
  );
};

export default AskAIWidget;
